import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddCurricularComponent } from '../add-curricular/add-curricular.component';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { Term } from 'src/app/stores/administrator/term.store';
import { Master } from 'src/app/stores/administrator/master.store';

@Component({
  selector: 'app-curriculum',
  templateUrl: './curriculum.component.html',
  styleUrls: ['./curriculum.component.scss']
})
export class CurriculumComponent implements OnInit {
  SELECTED_FACULTY: any = null;
  SELECTED_PROGRAM: any = null;

  tabs: any[] = [];

  constructor(
    private auth: AuthService,
    private list: List,
    private route: ActivatedRoute,
    public store: Term,
    private ds: DataService,
    public master: Master,
    public dialog: MatDialog) { }

  create() {
    const dialogRef = this.dialog.open(AddCurricularComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  async ngOnInit() {
    await this.auth.fetchEnvironment()
    this.route.parent.parent.params.subscribe(async params => {
      const { id } = params;
      this.SELECTED_FACULTY = id;
      this.master.SELECTED_FACULTY=id;
      this.route.params.subscribe(async params => {
        const { program } = params;
        this.SELECTED_PROGRAM = program;
        this.master.SELECTED_PROGRAM = program;
        this.store.fetchData(this.ds.curricularRef(ref => ref.where('facultyKey', "==", this.SELECTED_FACULTY).where("degreeKey","==",this.SELECTED_PROGRAM).orderBy('name')))
      })
    })
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
